import { render, staticRenderFns } from "./ValidationInput.vue?vue&type=template&id=0ca630f3&scoped=true"
import script from "./ValidationInput.vue?vue&type=script&lang=js"
export * from "./ValidationInput.vue?vue&type=script&lang=js"
import style0 from "./ValidationInput.vue?vue&type=style&index=0&id=0ca630f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca630f3",
  null
  
)

export default component.exports